import { Stack } from '@mui/system';
import { TreeItem } from '@mui/x-tree-view';
import type { StatusesByField } from 'business/types';
import FieldStatusChip from 'components/SharedComponents/FieldStatusInformation/FieldStatusChip';
import DataTypeIcon from 'modules/datacatalog/components/DataTypeIcon/DataTypeIcon';
import type {
    CatalogSelection,
    CatalogTreeField,
} from 'modules/datacatalog/types';

import StyHighlightableLabel from './StyHighlightableLabel';

type Props = {
    field: CatalogTreeField;
    domain: string;
    category: string;
    isSelected: boolean;
    onSelect: (selection: CatalogSelection) => void;
    searchQuery?: string;
    displayedStatuses?: StatusesByField;
};

const FieldRenderer = ({
    field,
    domain,
    category,
    isSelected,
    onSelect,
    searchQuery = undefined,
    displayedStatuses,
}: Props) => {
    const isDirectMatch =
        !!searchQuery &&
        field.label.toLowerCase().includes(searchQuery.toLowerCase());

    if (field.type === 'table') return null; // Do not display tables at the field level, they are rendered separately in the CategoryRenderer
    return (
        <TreeItem
            itemId={`${domain}-field-${field.field}`}
            onClick={(e) => {
                e.stopPropagation();
                onSelect({
                    kind: 'field',
                    name: field.field,
                    item: field,
                    domain,
                    category,
                });
            }}
            label={
                <Stack
                    direction="row"
                    spacing={0.75}
                    sx={{
                        alignItems: 'center',
                        py: 0.25,
                    }}
                >
                    <DataTypeIcon type={field.type} />
                    <StyHighlightableLabel
                        label={field.label}
                        isSelected={isSelected}
                        isDirectMatch={isDirectMatch}
                    />
                    {displayedStatuses && (
                        <FieldStatusChip
                            currentStatus={displayedStatuses[field.field]}
                        />
                    )}
                </Stack>
            }
        />
    );
};

export default FieldRenderer;
